@if (loader) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
<div class="modal-header mef-modal-header">
    <h3 class="modal-title">
        Filing and Mef/Efile Changes
        <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px; cursor: pointer;" (click)="minimise = !minimise"></i>
    </h3>
</div>
<div class="modal-body mef-modal-body" [hidden]="minimise">
<div class="mainContainer mef-efile-wrapper">
    <!-- AppKit4: responsive tab strip uses absolute positioning inside a scroll region; in modals
         it often clips or measures width as 0. Use non-responsive + stretched for a stable tab row. -->
    <ap-tabset [tabsetId]="'mef-efile-main-tabset'" [styleClass]="'gtw-tabset mef-main-tabset'" [type]="'underline'" [responsive]="false" [stretched]="false" [activeIndex]="mainTabIndex" (activeIndexChange)="onTabChanged($event)">
        <ap-tab [label]="'Delete Filing and Sync Mef/Efile Tables'">
            @if (mainTabIndex === 0) {
<div>
            <div class="card m-3 mef-card">

                <div class="card-body">
                    <div class="mef-delete-tab-content a-overflow-visible">
                        <div class="mef-checkbox-grid">
                            <ap-checkbox [styleClass]="'mef-checkbox-cell'"
                                [ngModel]="isTableSelected('TGT_MEF_CONSOL_ENTITIES')"
                                [disabled]="allCheckboxesDisable || mefTablesDisable"
                                (onChange)="clicked($event, 'TGT_MEF_CONSOL_ENTITIES', 1)">
                                <span>TGT_MEF_CONSOL_ENTITIES</span>
                            </ap-checkbox>
                            <ap-checkbox [styleClass]="'mef-checkbox-cell'"
                                [ngModel]="isTableSelected('TGT_MEF_CONSOL_GROUP')"
                                [disabled]="!isParent || allCheckboxesDisable || mefTablesDisable"
                                (onChange)="clicked($event, 'TGT_MEF_CONSOL_GROUP', 2)">
                                <span>TGT_MEF_CONSOL_GROUP</span>
                            </ap-checkbox>
                            <ap-checkbox [styleClass]="'mef-checkbox-cell'"
                                [ngModel]="isTableSelected('TGT_FILING_ENTITY_ASSIGN')"
                                [disabled]="allCheckboxesDisable"
                                (onChange)="clicked($event, 'TGT_FILING_ENTITY_ASSIGN', 3)">
                                <span>TGT_FILING_ENTITY_ASSIGN</span>
                            </ap-checkbox>
                            <ap-checkbox [styleClass]="'mef-checkbox-cell'"
                                [ngModel]="isTableSelected('TGT_FILING_GROUP')"
                                [disabled]="!isParent || allCheckboxesDisable"
                                (onChange)="clicked($event, 'TGT_FILING_GROUP', 4)">
                                <span>TGT_FILING_GROUP</span>
                            </ap-checkbox>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div *ngIf="loader" class="text-center rounded"><span class="a-loading a-primary" style="width: 24px; height: 24px; margin: 2px;"></span></div> -->
            <div class="a-modal-footer modal-footer pad-zero mef-footer">

                <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3 mef-btn-cancel" [btnType]="'secondary'"
                    (onClick)="cancel()"></ap-button>
                <div>
                    <ap-button [label]="'DELETE'" class="ap-mr-spacing-3 mef-btn-action" [btnType]="'secondary'"
                        (onClick)="deleteMefEfileData()"></ap-button>
                </div>
                <!-- <ap-button [btnText]="'MEF SYNC DELETE'" class="ap-mr-spacing-3" [config]="secondaryConfig"
                        (onBtnClick)="sync('MEF_SYNC_DELETE')" [isDisabled]="fgEmpty || !syncButtonsEnabled"></ap-button> -->
                <ap-button [label]="'MEF SYNC DELETE'" class="ap-mr-spacing-3 mef-btn-action" [btnType]="'secondary'"
                    (onClick)="openDialog()" [disabled]="fgEmpty || !syncButtonsEnabled"></ap-button>
                <ap-button [label]="'MEF SYNC'" class="ap-mr-spacing-3 mef-btn-action" [btnType]="'secondary'"
                    (onClick)="sync('MEF_SYNC')" [disabled]="fgEmpty || !syncButtonsEnabled"></ap-button>
                <ap-button [label]="'EFILE SYNC'" class="ap-mr-spacing-3 mef-btn-action" [btnType]="'secondary'"
                    (onClick)="sync('EFILE_SYNC')" [disabled]="fgEmpty || !syncButtonsEnabled"></ap-button>

            </div>
            </div>
}
        </ap-tab>
        <ap-tab [label]="'Insert Filing Data'">
            @if (mainTabIndex === 1) {
<div>
            <div class="card m-3 mef-card">
                <div class="nestedContainer">
                    <ap-tabset class="nestedTab" [tabsetId]="'mef-efile-nested-tabset'" [styleClass]="'gtw-tabset gtw-tabset-nested'" [type]="'underline'" [responsive]="false" [stretched]="false" [activeIndex]="nestedTabIndex" (activeIndexChange)="onNestedTabChanged($event)">
                        <ap-tab [label]="'TGT_FILING_GROUP'">
                            @if (nestedTabIndex === 0) {
<div>
                            <div class="card-body">
                                <form [formGroup]="formOne" novalidate>
                                    <div class="container mef-form-container">

                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="consolGroupKey">Consol Group Key</label>
                                                    <ap-field [title]="''" [fieldId]="'consolGroupKey'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        class="not-disabled"
                                                        [error]="formOne.controls.consolGroupKey.touched && formOne.controls.consolGroupKey.invalid">
                                                        <input appkit-field aria-label="Consol Group Key" formControlName="consolGroupKey" id="consolGroupKey" />
                                                    </ap-field>
                                                    @if (formOne.controls.consolGroupKey.touched && formOne.controls.consolGroupKey.invalid) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="filingGroupName">Filing Group Name</label>
                                                    <ap-field [title]="''" [fieldId]="'filingGroupName'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="Filing Group Name" formControlName="filingGroupName" id="filingGroupName" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="parentLeKey">Parent LE Key</label>
                                                    <ap-field [title]="''" [fieldId]="'parentLeKey'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="Parent LE Key" formControlName="parentLeKey" id="parentLeKey" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="returnDate">Return Date</label>
                                                    <ap-field [title]="''" [fieldId]="'returnDate'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [attachedDOM]="'body'"
                                                        [adaptivePosition]="true"
                                                        [datepicker]="true" [dpType]="'single'" [dpRange]="false"
                                                        [editable]="false"
                                                        [dpMinDate]="beginDate" [dpDateformat]="'MM/dd/yyyy'"
                                                        [dpSelectedDates]="returnDateDates"
                                                        (dpSelectedDatesChange)="onSelectedDatesChange($event, 'returnDate')"
                                                        (onShow)="onDatepickerShow('returnDate')"
                                                        (onClose)="onDatepickerClose()"
                                                        [error]="formOne.controls.returnDate.touched && formOne.controls.returnDate.invalid"
                                                        class="not-disabled">
                                                        <input appkit-field aria-label="Return Date" id="returnDate" />
                                                    </ap-field>
                                                    @if (formOne.controls.returnDate.touched && formOne.controls.returnDate.invalid) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="irsCenterName">IRS Center Name</label>
                                                    <ap-field [title]="''" [fieldId]="'irsCenterName'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        class="not-disabled"
                                                        [error]="formOne.controls.irsCenterName.touched && formOne.controls.irsCenterName.invalid">
                                                        <input appkit-field aria-label="IRS Center Name" formControlName="irsCenterName" id="irsCenterName" />
                                                    </ap-field>
                                                    @if (formOne.controls.irsCenterName.touched && formOne.controls.irsCenterName.invalid) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="filterTaxYearBegin">Filing Tax Year Begin</label>
                                                    <ap-field [title]="''"
                                                        [fieldId]="'filterTaxYearBegin'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [attachedDOM]="'body'"
                                                        [adaptivePosition]="true"
                                                        [datepicker]="true"
                                                        [dpType]="'single'" [dpRange]="false"
                                                        [editable]="false"
                                                        [dpMinDate]="beginDate" [dpMaxDate]="endDate"
                                                        [dpDateformat]="'MM/dd/yyyy'"
                                                        [dpSelectedDates]="filterTaxYearBeginDates"
                                                        (dpSelectedDatesChange)="onSelectedDatesChange($event, 'filterTaxYearBegin')"
                                                        (onShow)="onDatepickerShow('filterTaxYearBegin')"
                                                        (onClose)="onDatepickerClose()"
                                                        [error]="formOne.controls.filterTaxYearBegin.touched && formOne.controls.filterTaxYearBegin.invalid"
                                                        class="not-disabled">
                                                        <input appkit-field aria-label="Filing Tax Year Begin" id="filterTaxYearBegin" />
                                                    </ap-field>
                                                    @if (formOne.controls.filterTaxYearBegin.touched && formOne.controls.filterTaxYearBegin.invalid) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="filterTaxYearEnd">Filing Tax Year End</label>
                                                    <ap-field [title]="''"
                                                        [fieldId]="'filterTaxYearEnd'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [attachedDOM]="'body'"
                                                        [adaptivePosition]="true"
                                                        [datepicker]="true"
                                                        [dpType]="'single'" [dpRange]="false"
                                                        [editable]="false"
                                                        [dpMinDate]="beginDate" [dpMaxDate]="endDate"
                                                        [dpDateformat]="'MM/dd/yyyy'"
                                                        [dpSelectedDates]="filterTaxYearEndDates"
                                                        (dpSelectedDatesChange)="onSelectedDatesChange($event, 'filterTaxYearEnd')"
                                                        (onShow)="onDatepickerShow('filterTaxYearEnd')"
                                                        (onClose)="onDatepickerClose()"
                                                        [error]="formOne.controls.filterTaxYearEnd.touched && formOne.controls.filterTaxYearEnd.invalid"
                                                        class="not-disabled">
                                                        <input appkit-field aria-label="Filing Tax Year End" id="filterTaxYearEnd" />
                                                    </ap-field>
                                                    @if (formOne.controls.filterTaxYearEnd.touched && formOne.controls.filterTaxYearEnd.invalid) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="a-modal-footer modal-footer pad-zero mef-footer">

                                <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3 mef-btn-cancel"
                                    [btnType]="'secondary'" (onClick)="cancel()">
                                </ap-button>
                                <div>
                                    <ap-button [label]="'SAVE'" class="ap-mr-spacing-3 mef-btn-action"
                                        [btnType]="'secondary'" [disabled]="disableSave"
                                        (onClick)="insertFilingData()"></ap-button>
                                </div>

                            </div>
                            </div>
}
                        </ap-tab>
                        <ap-tab [label]="'TGT_FILING_ENTITY_ASSIGN'">
                            @if (nestedTabIndex === 1) {
<div>

                            <div class="card-body">
                                <form [formGroup]="formTwo" novalidate>
                                    <div class="container mef-form-container filing-entity-form">

                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="filingGroupKey">Filing Group Key</label>
                                                    <ap-field [title]="''" [fieldId]="'filingGroupKey'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        class="not-disabled"
                                                        [error]="isFilingGroupKeyError()">
                                                        <input appkit-field aria-label="Filing Group Key" formControlName="filingGroupKey" id="filingGroupKey" />
                                                    </ap-field>
                                                    @if (isFilingGroupKeyError()) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="leKey">LE Key</label>
                                                    <ap-field [title]="''" [fieldId]="'leKey'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="LE Key" formControlName="leKey" id="leKey" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="dateFiled">Date Filed</label>
                                                    <ap-field [title]="''" [fieldId]="'dateFiled'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [attachedDOM]="'body'"
                                                        [adaptivePosition]="true"
                                                        [datepicker]="true" [dpType]="'single'" [dpRange]="false"
                                                        [editable]="false"
                                                        [dpMinDate]="beginDate" [dpMaxDate]="endDate"
                                                        [dpDateformat]="'MM/dd/yyyy'"
                                                        [dpSelectedDates]="dateFiledDates"
                                                        (dpSelectedDatesChange)="onSelectedDatesChange($event, 'dateFiled')"
                                                        (onShow)="onDatepickerShow('dateFiled')"
                                                        (onClose)="onDatepickerClose()"
                                                        [error]="isDateFiledError()"
                                                        class="not-disabled">
                                                        <input appkit-field aria-label="Date Filed" id="dateFiled" />
                                                    </ap-field>
                                                    @if (isDateFiledError()) {
<div
                                                        class="a-form-error">This is a required field</div>
}
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="lockYN">Lock Y N</label>
                                                    <ap-field [title]="''" [fieldId]="'lockYN'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="Lock Y N" formControlName="lockYN" id="lockYN" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="fgnDomFlag">FGN Dom Flag</label>
                                                    <ap-field [title]="''" [fieldId]="'fgnDomFlag'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="FGN Dom Flag" formControlName="fgnDomFlag" id="fgnDomFlag" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="leConsolTypeFlag">LE Consol Type Flag</label>
                                                    <ap-field [title]="''" [fieldId]="'leConsolTypeFlag'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        class="not-disabled">
                                                        <input appkit-field aria-label="LE Consol Type Flag" formControlName="leConsolTypeFlag" id="leConsolTypeFlag" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="a-form-label" for="filerStatus">Filer Status</label>
                                                    <ap-field [title]="''" [fieldId]="'filerStatus'"
                                                        [hideTitleOnInput]="true"
                                                        [styleClass]="'mef-compact-field'"
                                                        [disabled]="disabled">
                                                        <input appkit-field aria-label="Filer Status" formControlName="filerStatus" id="filerStatus" />
                                                    </ap-field>
                                                </div>
                                            </div>
                                            <div class="col-6"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="a-modal-footer modal-footer pad-zero mef-footer">

                                <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3 mef-btn-cancel"
                                    [btnType]="'secondary'" (onClick)="cancel()">
                                </ap-button>
                                <div>
                                    <ap-button [label]="'SAVE'" class="ap-mr-spacing-3 mef-btn-action"
                                        [btnType]="'secondary'" (onClick)="insertEntityAssignData()"></ap-button>
                                </div>

                            </div>
                            </div>
}

                        </ap-tab>
                    </ap-tabset>
                </div>

            </div>
            </div>
}

        </ap-tab>
    </ap-tabset>
</div>
</div>